/*
 * @Author: 吴俊杰_20717 20717@etransfar.com
 * @Date: 2022-12-25 14:00:54
 * @LastEditors: 吴俊杰_20717 20717@etransfar.com
 * @LastEditTime: 2022-12-26 15:23:20
 * @FilePath: /lytMobile/src/routes/personalInfo/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { Component } from "react";
import { Toast,List } from "antd-mobile";
import styles from './index.less';
export default class contractManage extends Component {
  state = {
    
  }

  componentDidMount() {

  }


  render() {
    return (
      <div className={styles.personal}>
            <div className="list"><div className="label">会员名</div><div className="info">HYM2019080801</div></div>
            <div className="list"><div className="label">所属商户名</div><div className="info">陆运通测试专用号</div></div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/personalInfo/personal/index.js